import React, { useState } from "react";
import CouponsManager from "../components/CouponsManager";
import CouponsDemo from "../components/CouponsDemo";

const CouponsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"manager" | "demo">("manager");

  return (
    <div className="container-fluid">
      {/* Page Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="mb-1">Coupons</h1>
          <p className="text-muted mb-0">
            Manage your WooCommerce discount coupons and promotions
          </p>
        </div>
      </div>

      {/* Navigation Tabs */}
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "manager" ? "active" : ""}`}
            onClick={() => setActiveTab("manager")}
          >
            <i className="fas fa-cogs me-2"></i>
            Coupons Manager
          </button>
        </li>
        {/* <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "demo" ? "active" : ""}`}
            onClick={() => setActiveTab("demo")}
          >
            <i className="fas fa-info-circle me-2"></i>
            Features Demo
          </button>
        </li> */}
      </ul>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "manager" && (
          <div className="tab-pane fade show active">
            <CouponsManager />
          </div>
        )}

        {activeTab === "demo" && (
          <div className="tab-pane fade show active">
            <CouponsDemo />
          </div>
        )}
      </div>
    </div>
  );
};

export default CouponsPage;
